export class CategoryType {
  public static PROVIDER = 1;
  public static CONSUMER = 2;
  public static EDU_STAFF = 3;
  public static EDU_FAMILY = 4;
}
